export const IFRAME_WALLET_ID = 'iframe';
export const IFRAME_KEYSTORECHANGE_EVENT = 'iframe_keystorechange';
export const IFRAME_PARENT_DISCONNECTED = 'Parent wallet not connected.';
//# sourceMappingURL=iframe.js.map